/*
This Store contains ALL active articles in Shopware including tray articles (unlike the ArticlesStore)
 */

import Store from './Store';

const ArticlesStoreSW = new Store('articles/active/shopware');

export {ArticlesStoreSW};